/* eslint-disable react/no-multi-comp */
/* eslint-disable max-classes-per-file */

import React from 'react';
import {
  Tabs as ReactTabs,
  TabList as ReactTabList,
  Tab as ReactTab,
  TabPanel as ReactTabPanel,
  TabsProps,
} from 'react-tabs';

class Tabs extends React.Component<{ onSelect: TabsProps['onSelect'] }> {
  static tabsRole: string = 'Tabs';

  render() {
    const { children, onSelect, ...rest } = this.props;
    return (
      <ReactTabs
        {...rest}
        onSelect={onSelect}
        className=""
        selectedTabClassName="is-active"
      >
        {children}
      </ReactTabs>
    );
  }
}

class TabList extends React.Component {
  static tabsRole: string = 'TabList';

  render() {
    const { children, ...rest } = this.props;
    return (
      <ReactTabList {...rest} className="tabs">
        {children}
      </ReactTabList>
    );
  }
}

class Tab extends React.Component {
  static tabsRole: string = 'Tab';

  render() {
    const { children, ...rest } = this.props;
    return (
      <ReactTab {...rest} className="tabs-title">
        {children}
      </ReactTab>
    );
  }
}

class TabPanel extends React.Component {
  static tabsRole: string = 'TabPanel';

  render() {
    const { children, ...rest } = this.props;
    return <ReactTabPanel {...rest}>{children}</ReactTabPanel>;
  }
}

export { Tab, TabList, Tabs, TabPanel };

/* eslint-enable react/no-multi-comp */
/* eslint-enable max-classes-per-file */
